// Copyright © 2021 Move Closer
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var PaywallTabs;
(function (PaywallTabs) {
    PaywallTabs["Buy"] = "buy";
    PaywallTabs["Register"] = "register";
})(PaywallTabs || (PaywallTabs = {}));
